import { render, staticRenderFns } from "./ProviderApprovaltable.vue?vue&type=template&id=c4a47ab0&scoped=true&"
import script from "./ProviderApprovaltable.vue?vue&type=script&lang=js&"
export * from "./ProviderApprovaltable.vue?vue&type=script&lang=js&"
import style0 from "./ProviderApprovaltable.vue?vue&type=style&index=0&id=c4a47ab0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a47ab0",
  null
  
)

export default component.exports